import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ContextMenu from "../ContextMenu/ContextMenu";
import { MenuItem, MenuList, Paper } from "@mui/material";
import { cloneDeep } from 'lodash';
import { useDispatch } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

const TradingPartnerContextMenu = ({data,setSelectedLookup,setData,updateTree,selectedLookup,updateRedux, setSelectedLookupNode}) => {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const dispatch = useDispatch();

  const newLookupHandler = ()=> {
    const treeData = [...(cloneDeep(data) || [])];
    const newNode ={
      FIELDTYPE: "CONSTANT",
      VALUE: ''
    }
    treeData.push(newNode);
    updateTree(treeData);
    setData(treeData)
    setSelectedLookup([`tp-${treeData.length-1}`]);
    setSelectedLookupNode(newNode)
    dispatch(treeActions.setTradingPartner({
      screen:parentScreen,
      value:treeData
    }))
  }

  const deleteLookupHandler = ()=> {
    const treeData = [...(cloneDeep(data) || [])];
    const index = Number(selectedLookup[0].split('-')[1]);
    
    treeData.splice(index,1);
    setData(treeData)
    updateTree(treeData);
    if(!treeData.length){
      setSelectedLookup([])
      setSelectedLookupNode({});
    }
    else if(index === 0) {
      setSelectedLookup([`tp-0`]);
      setSelectedLookupNode(treeData?.[0] || {});
    }
    else {
      setSelectedLookup([`tp-${index-1}`])
      setSelectedLookupNode(treeData?.[index - 1] || {});
    };
    dispatch(treeActions.setTradingPartner({
      screen:parentScreen,
      value:treeData
    }))
  }


  return (
    <ContextMenu targetId="tradingPartner">
      <Paper style={{ width: "19rem" }}>
        <MenuList vertical="true">
          <MenuItem
            onClick={newLookupHandler}
            name={t("MNU_NEW_LOOKUP_FLD")}
          >
            <span className={"QUERY"}></span>
            <span className={"margin-left-8"}>
              {t("MNU_NEW_LOOKUP_FLD")}
            </span>
          </MenuItem>
          <MenuItem
            disabled={!selectedLookup?.length}
            onClick={deleteLookupHandler}
            name={t("MNU_DEL_SEL_FLD_RULE")}
          >
            <span className={"SYMBOL_DELETE"}></span>
            <span className={"margin-left-8"}>{t("MNU_DEL_SEL_FLD_RULE")}</span>
          </MenuItem>
        </MenuList>
      </Paper>
    </ContextMenu>
  );
};

export default TradingPartnerContextMenu;
